<template>
	<div v-loading="element_loading" element-loading-text="拼命加载中......" element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<div class="title">
			<div id="notice">
				<h5>收款计划明细&nbsp;&nbsp;说明:</h5><br>
				<span>1、查询收款流水的对应明细，可以导出</span><br>
					<span>2、查询关键字:业务单号、车牌、付款人、付款人电话、签订日期、到期日期、是否逾期、关联订单、申请类型</span><br>
			</div>
		</div>
		<!-- 主+明细 -->
		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
			<!-- 
			<template slot="pre_tan_button">
				<button @click="edit_mode">添加收款明细</button>
				<button @click="edit_mode">发起延期申请</button>
			</template> -->
		</pre-base>


	</div>
</template>

<script>
	import api from '@/utils/type.js'

	import {
		Method_Common
	} from '@/utils/loadhttpdata.js';

	export default {
		components: {
			"pre-base": () => import("../auto/auto_view.vue")
		},
		data() {
			return {
				element_loading: false,
				init_data: '',
				row_id: '',
				item: '',

				// 组件
				show_tan: '0',
				show_item: ''
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {
				// let udata = GetShort('userdata');
				// let rname = '';
				// if (typeof(udata) !== 'undefined' && udata != '') {
				// 	let r = JSON.parse(udata);
				// 	rname = r[0].rname;
				// }
				// console.log('当前角色:' + rname);

				this.init_data = '';

				this.init_data = JSON.stringify({
					"control": "paydetaillist",
					"title": "收款明细流水",
					"isTwo": "0",
					"isTwoDetail": "0",
					"action_flag": "",
					"isFileMain": "1",
					"step": "0",
					"sel_action": 'exp_cw_paysheet_d_list',
					"upd_action": '',
					"tab_name_1": "",
					"tab_name_2": "",
					"detail_part": "0",
					"detail_excelup": "0",
					"d_btn_base": "1",
					"d_btn_more": "0",
					"d_sel_action": '',
					"d_upd_action": '',
					"file_action": '',
					"p1": '',
					"p2": '',
					"p3": '',
					"parm_sel": [
						{
							"name": "业务单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1"
						},
						{
							"name": "车牌",
							"val": "",
							"key": "car_no",
							"type": "text",
							"class": "long1"
						},
						{
							"name": "付款人",
							"val": "",
							"key": "pay_user",
							"type": "text",
							"class": "long1"
						},
						{
							"name": "付款人电话",
							"val": "",
							"key": "pay_userphone",
							"type": "text",
							"class": "long1"
						},
						{
							"name": "签订日期",
							"val": "",
							"key": "s_date",
							"type": "date",
							"class": "long1"
						},
						{
							"name": "到期日期",
							"val": "",
							"key": "e_date",
							"type": "date",
							"class": "long1"
						},
						{
							"name": "是否逾期",
							"val": "",
							"key": "wanning",
							"type": "select",
							"class": "long1",
							"list": [{
								"id": "1",
								"val": "否"
							}, {
								"id": "2",
								"val": "是"
							}],
							"sel_action": "",
							"sel_name": ""
						},
						{
							"name": "销售订单",
							"val": "",
							"key": "sheet_xs",
							"type": "text",
							"class": "long1"
						},
						{
							"name": "申请类型",
							"val": "",
							"key": "apply_class",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_pay_type",
							"sel_name": ""
						}
					],
					"parm": [],
					"parm_th": [{
							"name": "序号"
						},
						{
							"name": "业务单号"
						},
						{
							"name": "销售订单"
						},
						{
							"name": "经办人"
						},
						{
							"name": "状态"
						},						
						{
							"name": "开始日期"
						},
						{
							"name": "结束日期"
						},
						{
							"name": "全款金额"
						},
						{
							"name": "首付金额"
						},
						{
							"name": "几号还款"
						},
						{
							"name": "分期期数"
						},
						{
							"name": "年利息"
						},
						{
							"name": "滞纳金比例"
						},						
						{
							"name": "提前预警天数"
						},
						{
							"name": "车牌"
						},
						{
							"name": "付款方"
						},
						{
							"name": "付款方电话"
						},						
						{
							"name": "还款日期"
						},
						{
							"name": "原还款日期"
						},
						{
							"name": "应还本金"
						},
						{
							"name": "应还利息"
						},
						{
							"name": "计息天数"
						},
						{
							"name": "应交滞纳金"
						},
						{
							"name": "逾期天数"
						},
						{
							"name": "应收总额"
						},
						// {
						// 	"name": "待收总额"
						// },
						{
							"name": "收款顺序"
						},
						{
							"name": "本期收款"
						},
						{
							"name": "收款日期"
						},
						{
							"name": "已还利息"
						},
						{
							"name": "已还本金"
						},
						{
							"name": "已交滞纳金"
						},
						{
							"name": "实收总额"
						},
						{
							"name": "支付剩余"
						},
						{
							"name": "本期剩余"
						},
						{
							"name": "备注"
						},
						{
							"name": "修改人"
						},
						{
							"name": "更新时间"
						}


					],
					"d_parm": [],
					"d_name": [],

				});


			},
			refresh_data: function() {

				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data('1');
				});
			},
			refresh_father: function(type, val, parm) {
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						// this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			}




		}
	};
</script>
<style>
</style>